module.exports = __webpack_public_path__ + "static/media/Clock.22d072d9.svg";